import constants from "../../core/constants";
import moment from "moment";

class Controller {
  constructor(Events, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    const getDateValue = (date) => {
      if (constants.endDateRegex.test(date.key)) {
        return this.withTime
          ? moment(date.value).toDate().toISOString()
          : moment(date.value).endOf("day").toDate().toISOString();
      }
      return this.withTime
        ? moment(date.value).toDate().toISOString()
        : moment(date.value).startOf("day").toDate().toISOString();
    };
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to remove "${this.title}"?`)
      .textContent("If you chose to remove it you can add it again.")
      .ok("Remove")
      .cancel("Cancel");

    this.dateFormat = this.dateFormat || constants.dateFormat;
    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.onClear = () => {
      this.$mdDialog.show(confirm).then(
        () => {
          this.selected.value = null;
          this.Events.emit(this.eventName, this.selected);
        },
        () => {}
      );
    };

    this.submitField = () => {
      const options = {
        key: this.selected.key,
        value: getDateValue(this.selected),
        method: this.resourceMethod,
        methodName: this.resourceMethodName,
      };

      if (this.extraParams) options.extraParams = this.extraParams;

      this.Events.emit(this.eventName, options);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableDate/editableDate.controller.js